import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStyles } from '../../contexts/StyleContext';
import Button from './Button';
import { theme } from '../../styles/theme';

const Header = ({ user, setUser, title }) => {
  const styles = useStyles();
  const { header } = styles;
  const location = useLocation();

  const handleSignOut = async () => {
    try {
      setUser(null);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const isLandingPage = location.pathname === '/';

  const mainNavItems = [
    { path: '/max-comply', label: 'Max_Comply' },
    { path: '/sms-prime', label: 'SMS_Prime' },
    { path: '/rca-pro', label: 'RCA_Pro' },
    { path: '/just-culture', label: 'Just_Culture_Flow' }
  ];

  const containerClasses = `
    flex 
    flex-col
    bg-white 
    border-b 
    shadow-sm
  `.trim();

  const containerStyle = {
    borderColor: header.container.borderColor
  };

  const logoContainerClasses = `
    flex 
    justify-between
    items-center 
    px-6 
    py-4
  `.trim();

  const logoClasses = `
    h-24 
    w-auto
    cursor-pointer
    transition-transform
    duration-200
    hover:scale-105
  `.trim();

  const titleContainerClasses = `
    flex 
    flex-col
  `.trim();

  const titleClasses = `
    text-2xl 
    font-bold
  `.trim();

  const titleStyle = {
    color: header.title.color
  };

  const backLinkClasses = `
    text-sm 
    hover:underline
    mt-1
    flex
    items-center
    space-x-1
    cursor-pointer
  `.trim();

  const backLinkStyle = {
    color: theme.colors.secondary.main
  };

  const navigationClasses = `
    flex 
    items-center 
    space-x-4
  `.trim();

  const userInfoClasses = `
    text-sm 
    mr-4
  `.trim();

  const userInfoStyle = {
    color: header.subtitle.color
  };

  return (
    <header className={containerClasses} style={containerStyle}>
      <div className={logoContainerClasses}>
        <div className="flex items-center space-x-6">
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="Aviation Synergy Logo" 
              className={logoClasses}
            />
          </Link>
          <div className={titleContainerClasses}>
            <div className={titleClasses} style={titleStyle}>
              {title || 'Aviation Management System Toolkit'}
            </div>
            {!isLandingPage && location.pathname !== '/max-comply' && 
             location.pathname !== '/sms-prime' && location.pathname !== '/rca-pro' && 
             location.pathname !== '/just-culture' && (
              <Link 
                to={location.pathname.split('/').slice(0, 2).join('/')} 
                className={backLinkClasses}
                style={backLinkStyle}
              >
                <svg 
                  className="w-4 h-4" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M15 19l-7-7 7-7" 
                  />
                </svg>
                <span>Back</span>
              </Link>
            )}
          </div>
        </div>
        
        <div className={navigationClasses}>
          {user && (
            <>
              <div className={userInfoClasses} style={userInfoStyle}>
                Logged in as: {user.email}
              </div>
              <Button
                variant="accent"
                onClick={handleSignOut}
              >
                Sign Out
              </Button>
            </>
          )}
        </div>
      </div>

      {!isLandingPage && user && (
        <div className="w-full bg-[#0A2647]">
          <nav className="flex justify-center items-center px-6 py-2 max-w-7xl mx-auto">
            <div className="grid grid-cols-4 gap-16 w-full max-w-5xl">
              {mainNavItems.map((item) => {
                const isActive = location.pathname.startsWith(item.path);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`
                      px-6
                      py-2
                      rounded-lg
                      font-medium
                      transition-all
                      duration-200
                      text-center
                      ${isActive 
                        ? 'bg-white text-[#0A2647] shadow-md' 
                        : 'text-white hover:-translate-y-0.5 hover:bg-white/10'
                      }
                    `}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
